const SETTINGS_NAME_AND_VERSION_PATTERN =
  /^[A-Za-z0-9][A-Za-z0-9._:+|=@-]{0,511}$/;

export const commonRunEditState = (
  settingsNameAndVersion: unknown,
): "none" | "saved" | undefined => {
  if (
    typeof settingsNameAndVersion !== "string" ||
    !SETTINGS_NAME_AND_VERSION_PATTERN.test(settingsNameAndVersion) ||
    settingsNameAndVersion.includes("..") ||
    settingsNameAndVersion.split("|").length !== 2
  ) {
    return undefined;
  }
  return settingsNameAndVersion.split("|", 1)[0].startsWith("layer_edit_")
    ? "saved"
    : "none";
};
